import { Button, ButtonGroup } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'

const menuItems = [
  { label: 'Overview', path: '/statistics' },
  { label: 'Pass Activity', path: '/statistics/pass-activity' },
  { label: 'Adoption', path: '/statistics/adoption' },
  { label: 'Template Changes', path: '/statistics/template-changes' },
  { label: 'Installs', path: '/statistics/installs' },
  { label: 'Scans', path: '/statistics/scans' },
  { label: 'Pass Types', path: '/statistics/pass-types' }
]

const Menu = () => {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div className='flex flex-row justify-end w-full'>
      <ButtonGroup variant="text" aria-label="Statistics sections">
        {menuItems.map(item => (
          <Button
            key={item.path}
            onClick={() => navigate(item.path)}
            sx={{ color: location.pathname === item.path ? 'link' : 'text.secondary' }}
          >
            {item.label}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  )
}

export default Menu
